import { createTextarea } from "./createTextarea";

export const Textarea = createTextarea({ rows: 3 });
